import * as React from "react";

import { Sticky } from "../Sticky/Sticky";
import { useUnitLayoutingContext } from "../../FormParts/Unit/Internals/UnitBorderContext/UnitLayoutingContext";
import { useCandyTheme } from "../../Internals/ThemeProvider/CandyTheme/UseCandyTheme";

import { Colgroup } from "./Colgroup";
import { FooterRoot, FooterTable } from "./Footer.styles";

interface FooterProps {
    children: JSX.Element;
    columnWidth: number[];
    horizontalScroll: number;
    width: number;
    setRefSticky: (x: null | Sticky) => void;
}

export function Footer(props: FooterProps): JSX.Element {
    const theme = useCandyTheme();
    const unitLayouting = useUnitLayoutingContext();

    return (
        <div
            style={{
                paddingLeft: unitLayouting.paddingLeft,
                paddingRight: unitLayouting.paddingRight,
            }}>
            <Sticky
                background={theme.keyPalette.primaryBackgroundColor}
                allWidth
                isLastRow
                ref={props.setRefSticky}
                horizontalScroll={props.horizontalScroll}
                width={props.width}>
                <FooterRoot marginLeft={-props.horizontalScroll}>
                    <FooterTable>
                        <Colgroup columnWidth={props.columnWidth} />
                        <tbody>{props.children}</tbody>
                    </FooterTable>
                </FooterRoot>
            </Sticky>
        </div>
    );
}

interface StickyTableFooterRowProps {
    children: React.ReactNode;
}

export function StickyTableFooterRow(props: StickyTableFooterRowProps): JSX.Element {
    return <tr>{props.children}</tr>;
}
